import { render } from "./HomeMerit.vue?vue&type=template&id=280cdaf7&scoped=true"
import script from "./HomeMerit.vue?vue&type=script&lang=js"
export * from "./HomeMerit.vue?vue&type=script&lang=js"

import "./HomeMerit.vue?vue&type=style&index=0&id=280cdaf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280cdaf7"]])

export default __exports__